/* ════════════════════════════════════════════
   Nude Project Theme — Cart Drawer JavaScript
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', initCartDrawer);
  document.addEventListener('cart:drawer:refreshed', initCartDrawer);

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    // Quantity buttons (Using delegation on drawer, so this is robust)
    if (!drawer._hasQtyListener) {
      drawer.addEventListener('click', function(e) {
        var minusBtn = e.target.closest('[data-qty-minus]');
        var plusBtn = e.target.closest('[data-qty-plus]');
        var removeBtn = e.target.closest('[data-remove-item]');

        if (minusBtn) {
          e.preventDefault();
          var key = minusBtn.getAttribute('data-line-key');
          var qtyEl = minusBtn.closest('.cart-item__quantity').querySelector('[data-qty-value]');
          var currentQty = parseInt(qtyEl.textContent);
          if (currentQty > 1) {
            updateCartItem(key, currentQty - 1, qtyEl);
          } else {
            updateCartItem(key, 0, qtyEl);
          }
        }

        if (plusBtn) {
          e.preventDefault();
          var key = plusBtn.getAttribute('data-line-key');
          var qtyEl = plusBtn.closest('.cart-item__quantity').querySelector('[data-qty-value]');
          var currentQty = parseInt(qtyEl.textContent);
          updateCartItem(key, currentQty + 1, qtyEl);
        }

        if (removeBtn) {
          e.preventDefault();
          var key = removeBtn.getAttribute('data-line-key');
          updateCartItem(key, 0);
        }
      });
      drawer._hasQtyListener = true;
    }
  }

  function updateCartItem(key, quantity, qtyEl) {
    if (qtyEl) qtyEl.textContent = quantity;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (quantity === 0) {
        var item = document.querySelector('[data-line-key="' + key + '"]');
        if (item) item.remove();
      }

      // Check if cart is now empty
      if (cart.item_count === 0) {
        location.reload();
      }

      // Dispatch update
      if (window.Theme && window.Theme.Cart) {
        window.Theme.Cart.updateUI(cart);
      }

      // Update shipping progress
      updateShippingProgress(cart);
    })
    .catch(function(err) {
      console.error('Cart update failed:', err);
      if (qtyEl) location.reload();
    });
  }

  function updateShippingProgress(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var progressEl = drawer.querySelector('[data-shipping-progress]');
    if (!progressEl) return;

    var threshold = (window.theme && window.theme.freeShippingThreshold) || 15000;
    var remaining = threshold - cart.total_price;
    var progress = Math.min((cart.total_price / threshold) * 100, 100);

    var bar = progressEl.querySelector('.cart-drawer__shipping-fill');
    var text = progressEl.querySelector('.cart-drawer__shipping-text');

    if (bar) bar.style.width = progress + '%';
    if (text) {
      if (remaining > 0) {
        text.textContent = window.Theme ? window.Theme.formatMoney(remaining) : (remaining / 100).toFixed(2) + ' more for free shipping';
        text.classList.remove('cart-drawer__shipping-text--success');
      } else {
        // Do not show a celebratory message — keep the shipping text empty when threshold reached
        text.textContent = '';
        text.classList.remove('cart-drawer__shipping-text--success');
      }
    }
  }

})();
